export default "__VITE_ASSET__hznUwnCa__"